// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2xgyb","colMin":"styles_colMin__3ty9J"};